import {pathHelpContentFile} from '../../../utils/path';
import {CONTENT_TYPE_TEXT, CONTENT_TYPE_IMAGE, CONTENT_CATEGORY_DOCUMENT} from '../../constants';

export default {
  id: 'DEPOT_PASS_FUT_DOC',
  title: 'Come posso presentare un documento passato o a depositare in futuro?',
  description: '',
  categories: [CONTENT_CATEGORY_DOCUMENT],
  contents: [{
    type: CONTENT_TYPE_TEXT,
    value: 'Dalla scheda «Documenti»'
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '1.',
    value: 'Clicca sul documento di tua scelta'
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '2.',
    value: 'Fare clic sul pulsante «Aggiungere una nuova versione»'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}it/IT_DEPOT_PASS_FUT_DOC/IT_DEPOT_PASS_FUT_DOC.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '3.',
    value: 'Quindi procedere al deposito del documento'
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: 'Se il documento depositato è un documento passato, dopo l\'elaborazione da parte dei nostri team, viene ad aggiungersi ai vostri archivi.'
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: 'Se si tratta di un documento da depositare in futuro, esso completa o sostituisce il documento «In corso» dall\'inizio della sua validità.'
  }]
};
